/**
 * Centralized API configuration
 * Single source of truth for API base URL
 */

export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000'

export default API_BASE_URL
